import {ScheduleEntity} from "../../../proto/generated/api_entities_pb";
import {IAirport} from "../fleetReducer/fleetReducerTypes";
import {isValidDate, parseStringAsUTCDate} from "../../../utils/helpers/dateHelpers/dateHelpers";
import {
  mapAirportEntityToIAirport,
  mapPlaneShortEntityToIPlaneShort
} from "../fleetReducer/fleetMappers";
import {IPlaneEvent} from "./scheduleReducerTypes";


export const mapScheduleEntityToIPlaneEvent = (item: ScheduleEntity): IPlaneEvent => {
  const airportFrom = item.getAirportfrom();
  if (!airportFrom)
    throw new Error("Null AirportEntity (airportFrom) in received ScheduleEntity")
  const airportFromMapped = mapAirportEntityToIAirport(airportFrom);

  const airportTo = item.getAirportto();
  let airportToMapped: IAirport | undefined;
  if (airportTo)
    airportToMapped = mapAirportEntityToIAirport(airportTo);

  const planeShort = item.getPlane();
  if (!planeShort)
    throw new Error("Null PlaneShortEntity (plane) in received ScheduleEntity")

  // Парсим даты как UTC (как есть с бэкенда, без трансформации)
  const dateFrom = parseStringAsUTCDate(item.getDatefrom());
  if (!isValidDate(dateFrom))
    throw new Error(`Invalid dateFrom in received ScheduleEntity, ${item.getDatefrom()}`);

  const dateTo = parseStringAsUTCDate(item.getDateto());
  if (!isValidDate(dateTo))
    throw new Error(`Invalid dateTo in received ScheduleEntity, ${item.getDateto()}`);

  // Маппим самолёт с поддержкой planeType (будет приходить после расширения бэкендом)
  const mappedPlane = mapPlaneShortEntityToIPlaneShort(planeShort);
  
  // Если бэкенд расширил PlaneShortEntity и добавил planeType, маппим его
  // Проверяем наличие planeType через getPlanetype (если метод будет добавлен)
  const planeType = (planeShort as any).getPlanetype?.();
  if (planeType) {
    const planeCategory = planeType.getPlanecategory?.();
    if (planeCategory) {
      mappedPlane.planeType = {
        id: planeType.getPlanetypeid(),
        name: planeType.getName(),
        planeCategory: {
          id: planeCategory.getPlanecategoryid(),
          name: planeCategory.getName(),
        },
      };
    } else {
      // Если planeCategory отсутствует, создаем planeType без него (требуется для типа)
      mappedPlane.planeType = {
        id: planeType.getPlanetypeid(),
        name: planeType.getName(),
        planeCategory: {
          id: 0,
          name: '',
        },
      };
    }
  }

  // Проверяем, есть ли связанный empty leg (если empty leg создан на странице empty leg, а не на календаре)
  const emptyLeg = item.getEmptyleg();
  const hasEmptyLeg = emptyLeg !== null && emptyLeg !== undefined;
  // Проверяем, архивирован ли empty leg
  const isEmptyLegArchived = emptyLeg?.getArchived() ?? false;

  return {
    id: item.getScheduleid(),
    eventType: item.getScheduletype(),
    eventName: item.getSchedulename(),
    plane: mappedPlane,
    dateFrom: dateFrom,
    dateTo: dateTo,
    airportFrom: airportFromMapped,
    airportTo: airportToMapped,
    refuelingCount: item.getRefuelingcount(),
    pax: item.getPax(),
    isPublic: item.getIspublic(),
    hasEmptyLeg: hasEmptyLeg,
    isEmptyLegArchived: isEmptyLegArchived,
  }
};